
export default {
  placeDetails: {
    layer: 'Layer',
    lat: 'Lat.',
    lon: 'Lon.',
    notAvailable: 'Not available',
    placeDetails: 'Place details',
    placeName: 'Name',
    latlngCopied: 'Latitude and longitude copied',
    lnglatCopied: 'Longitude and latitude copied',
    copyLatlng: 'Copy in latitude,longitude format',
    copyLnglat: 'Copy in longitude,latitude format',
    satelliteView: 'satellite view'
  }
}
